﻿import type { RouteRecordRaw } from 'vue-router'

const purchaseRoutes: RouteRecordRaw = {
  path: '/purchase',
  name: 'Purchase',
  redirect: '/purchase/order',
  meta: { title: '采购管理', icon: 'icon-shopping' },
  children: [
    {
      path: 'request',
      name: 'MaterialRequest',
      component: () => import('@/views/purchase/MaterialRequestList.vue'),
      meta: { title: '采购申请', permissions: ['purchase:request:view'] },
    },
    {
      path: 'contract-request',
      name: 'ContractRequest',
      component: () => import('@/views/purchase/ContractRequestList.vue'),
      meta: { title: '采购合同', permissions: ['purchase:contract-request:view'] },
    },
    {
      path: 'order',
      name: 'PurchaseOrder',
      component: () => import('@/views/purchase/OrderList.vue'),
      meta: { title: '采购订单', permissions: ['purchase:order:view'] },
    },
    {
      path: 'receipt',
      name: 'PurchaseReceipt',
      component: () => import('@/views/purchase/ReceiptList.vue'),
      meta: { title: '进货入库', permissions: ['purchase:receipt:view'] },
    },
    {
      path: 'invoice',
      name: 'PurchaseInvoice',
      component: () => import('@/views/purchase/InvoiceList.vue'),
      meta: { title: '采购发票', permissions: ['purchase:invoice:view'] },
    },
    {
      path: 'return',
      name: 'PurchaseReturn',
      component: () => import('@/views/purchase/ReturnList.vue'),
      meta: { title: '采购退货', permissions: ['purchase:return:view'] },
    },
    {
      path: 'pay-request',
      name: 'PaymentRequest',
      component: () => import('@/views/purchase/RequestList.vue'),
      meta: { title: '付款申请', permissions: ['purchase:pay-request:view'] },
    },
    {
      path: 'payment',
      name: 'PurchasePayment',
      component: () => import('@/views/purchase/PaymentList.vue'),
      meta: { title: '付款结算', permissions: ['purchase:payment:view'] },
    },
    {
      path: 'landed-cost',
      name: 'LandedCost',
      component: () => import('@/views/purchase/LandedCostList.vue'),
      meta: { title: '到岸成本', permissions: ['purchase:landed-cost:view'] },
    },
  ],
}

export default purchaseRoutes
